import { MenuLink as MMMenuLink } from '@missionme/mime_elements';

export const MenuLink = MMMenuLink;
